export default {
  outList: [
    {
      light_point_1:[
        {
          title: '璀璨星河LED前大灯',
          type: 'image',
          video: '',
          image: 'lightPoint/out/1.png',
          text: ''
        }
      ],
      light_point_2:[
        {
          title: '贯穿式LED组合尾灯',
          type: 'image',
          video: '',
          image: 'lightPoint/out/4.png',
          text: ''
        }
      ],
      light_point_3:[
        {
          title: '前保气帘',
          type: 'image',
          video: '',
          image: 'lightPoint/out/3.png',
          text: ''
        }
      ],
      light_point_4:[
        {
          title: '贯穿式蜂窝状前中网',
          type: 'image',
          video: '',
          image: 'lightPoint/out/2.png',
          text: ''
        }
      ]
    }
  ],
  innerList: [
    {
      light_point_1:[
        {
          title: '10.25英寸炫彩仪表盘',
          type: 'image',
          video: '',
          image: 'lightPoint/in/1.png',
          text: ''
        }
      ],
      light_point_2:[
        {
          title: '10.25英寸智能显示屏',
          type: 'image',
          video: '',
          image: 'lightPoint/in/2.png',
          text: ''
        }
      ],
      light_point_3:[
        {
          title: 'LCD可视换挡杆',
          type: 'image',
          video: '',
          image: 'lightPoint/in/3.png',
          text: ''
        }
      ],
      light_point_4:[
        {
          title: '前排通风&加热座椅',
          type: 'image',
          video: '',
          image: 'lightPoint/in/4.png',
          text: ''
        }
      ],
      light_point_5:[
        {
          title: '后排中央扶手',
          type: 'image',
          video: '',
          image: 'lightPoint/in/5.png',
          text: ''
        }
      ],
      light_point_6:[
        {
          title: '无线充电&前/后排Type-c接口',
          type: 'image',
          video: '',
          image: 'lightPoint/in/6.png',
          text: ''
        }
      ],
      light_point_7:[
        {
          title: '氛围灯（71种颜色）',
          type: 'image',
          video: '',
          image: 'lightPoint/in/7.png',
          text: ''
        }
      ],
      light_point_8:[
        {
          title: '触控式自动空调',
          type: 'image',
          video: '',
          image: 'lightPoint/in/8.png',
          text: ''
        }
      ]
    }
  ]
}
